/**
 * Vision Valid Fields
 *
 * Set of valid field names for Vision benefits at the API level.
 * Used to filter out fields that don't belong to this coverage type.
 *
 * Note: These are the API-level field names (nested structure),
 * not the flattened grid field names.
 */

export const VISION_VALID_FIELDS = new Set([
  "objectType",
  "currentCarrierName",
  "eligibilityClasses",
  "networkBenefits",
  "networkName",
  "examFrequency",
  "lensesFrequency",
  "framesFrequency",
  "annualOpenEnrollment",
  "employerContribution",
  "extended",
]);
